<template>
  <div class="services-page">
    <!-- Banner -->
    <div class="page_vision_banner">
      <img src="/images/page_banner_news.jpg">
      <h3>
        <span>关于我们</span>
        <font></font>
        <strong>华合半导体将为您分享更多芯片和半导体业界的新进展</strong>
      </h3>
    </div>

    <!-- 面包屑 -->
    <div class="page_dg">
      <div>
        <left>
          <router-link to="/">主页</router-link> &gt;
          <router-link to="/about">关于我们</router-link>&gt;
          <router-link to="#">{{menu}}</router-link>
        </left>
      </div>
    </div>

    <!-- 服务列表 -->
    <div class="page_news">
      <div class="page_news_list">
        <left>
          <dl >
            <a v-for="(service, index) in aboutList.records" :key="index" @click="goToDetail(service)">
              <img :src="service.newImg">
              <h2>
                <b>{{ service.newNameCn }}</b>
                <c>{{ service.newSynopsisCn }}</c>
                <span class="read-more">阅读全文 &gt;</span>
                <e>{{ service.createTime }}</e>
              </h2>
            </a>
            <div class="feiye">
              共<strong>1</strong>页 <strong>{{ aboutList.total }}</strong>条
            </div>
          </dl>
        </left>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutList',
  metaInfo() {
    const menu = this.$route.query.menu || '关于我们'
    return {
      title: `${menu}_南京华合半导体_化合物半导体`,
      meta: [
        { name: 'description', content: `南京华合半导体${menu}，专注化合物半导体芯片研发，核心团队从业经验超10年，提供全产业链技术服务。` },
        { name: 'keywords', content: `${menu},南京华合半导体,公司概况,核心优势,合作案例,化合物半导体` },
        { name: 'robots', content: 'index,follow' }
      ]
    }
  },
  data() {
    return {
      menu: '',
      aboutList: {
        records: [],
        total: 0
      }
    }
  },
  created() {
    this.menu = this.$route.query.menu
   
    this.getAboutList()
  },
  methods: {
    getAboutList() {
      this.$request.get('/wx/news/getListByClassIfy',{"newType": this.$route.query.type} ).then(response => {
        this.aboutList = response.data
      })
    },
    goToDetail(service) {
         if(service.newNameEn){
        window.open(service.newNameEn)
        return 
      }
      this.$router.push({
        path: '/about/detail',
        query: { id: service.id ,menu: this.menu,type: this.$route.query.type}
      })
    }
  },
    watch: {
    '$route.query.menu'() {
      // console.log('路由变化了')
      this.menu = this.$route.query.menu
   
      this.getAboutList()
    }
  }
}
</script>

<style scoped>
.read-more {
  color: #0aacf2;
  font-size: 15px;
}

@media screen and (max-width: 740px) {
  .read-more {
    font-size: 12px;
    color: #0aacf2;
    margin-top: 0.5em;
  }
  .page_vision_banner {
        height: 150px;
        padding-top: 54px;
    }
}


</style>
